export enum BoardAccess {
  public = 'public',
  private = 'private',
  custom = 'custom',
}
